import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSingleMockRunDetails,
  updateMockRunStatus
} from '../../../actions/FieldAllocationAction';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { FIELD_ALLOCATION_KEY, MockTriggerType } from '../../../types';
import Modal from '@cp/src/components/Modal/Modal';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import ApprovalStep from './ApprovalStep';
import { getMockId } from '../../RightPanel/utils';
import { RootState } from '@cp/src/store';

interface IApproveMockModalProps {
  handleCloseModal: () => void;
  isVisible: boolean;
}

const ApproveMockModal: React.FC<IApproveMockModalProps> = ({
  handleCloseModal,
  isVisible = false
}) => {
  const dispatch = useDispatch();
  const queryParams = readQueryParams();

  const updateMockRunStatusLoading = useSelector(
    (state: RootState) => state.fieldAllocation?.updateMockRunStatusLoading
  );
  const previousAllocationDetails = useSelector(
    (state: RootState) => state?.fieldAllocation?.previousAllocationDetails
  );
  const isPreviousAllocationStatusLoading = useSelector(
    (state: RootState) => state?.fieldAllocation?.previousAllocationStatusLoading
  );

  const selectedMockId = queryParams[FIELD_ALLOCATION_KEY]?.selectedId;
  const approvedMockId = previousAllocationDetails?.allocationTrackerId || '';

  const successCallBack = () => {
    handleCloseModal();
    toast('Mock approved for allocation', { type: 'success' });
    dispatch(fetchSingleMockRunDetails(selectedMockId));
  };

  const onConfirm = () => {
    const payload = {
      status: MockTriggerType.APPROVE,
      allocationTrackerId: selectedMockId
    };
    dispatch(updateMockRunStatus(payload, successCallBack));
  };

  return (
    <Modal
      visible={isVisible}
      onClose={handleCloseModal}
      showCloseIcon={false}
      isHeaderRequired={!isPreviousAllocationStatusLoading}
      header={
        approvedMockId
          ? `Another mock ${getMockId(approvedMockId)} is already approved!`
          : 'Are you sure you want to approve this mock allocation?'
      }
      headerClassName="!px-6 !pt-6"
      contentClassName="min-w-[400px]"
      closeOnOutsideClick={!updateMockRunStatusLoading}
    >
      <ApprovalStep
        handleCloseModal={handleCloseModal}
        onConfirm={onConfirm}
        approvedMockId={approvedMockId}
        isLoading={isPreviousAllocationStatusLoading}
      />
    </Modal>
  );
};

export default ApproveMockModal;
